var map = {
	"./v1/accountsInformationRS.json": "./src/util/mocks/v1/accountsInformationRS.json",
	"./v1/backEventRS.json": "./src/util/mocks/v1/backEventRS.json",
	"./v1/checkoutEventRS.json": "./src/util/mocks/v1/checkoutEventRS.json",
	"./v1/confirmationViewedEventRS.json": "./src/util/mocks/v1/confirmationViewedEventRS.json",
	"./v1/downloadTicketRS.json": "./src/util/mocks/v1/downloadTicketRS.json",
	"./v1/modifyRS.json": "./src/util/mocks/v1/modifyRS.json",
	"./v1/modify_communication_interruptedRS.json": "./src/util/mocks/v1/modify_communication_interruptedRS.json",
	"./v1/modify_errorRS.json": "./src/util/mocks/v1/modify_errorRS.json",
	"./v1/modify_not_ticketRS.json": "./src/util/mocks/v1/modify_not_ticketRS.json",
	"./v1/modify_offert_priceRS.json": "./src/util/mocks/v1/modify_offert_priceRS.json",
	"./v1/priceRS.json": "./src/util/mocks/v1/priceRS.json",
	"./v1/travelItineraryReadRS.json": "./src/util/mocks/v1/travelItineraryReadRS.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/util/mocks sync recursive RS\\.json$";